import type { ReactNode } from 'react';
import { IdentityBar } from './IdentityBar';
import type { SlideDirection } from './paneMotion';
import type { PaneIdentity } from './paneIdentity';
import { SlideStage } from './SlideStage';

interface PaneLayoutProps {
    identity: PaneIdentity;
    today: string;
    // Changes whenever the view below the bar changes; the bar itself stays mounted.
    viewKey: string;
    slide: SlideDirection;
    children: ReactNode;
}

export function PaneLayout({ identity, today, viewKey, slide, children }: PaneLayoutProps) {
    return (
        <div className="flex h-full min-h-0 flex-col">
            <IdentityBar identity={identity} today={today} />
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SlideStage key={viewKey} direction={slide}>
                    {children}
                </SlideStage>
            </div>
        </div>
    );
}
